var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var atan2 = Math.atan2, π = Math.PI;
var flatMap = function (cb, array) {
    return array.reduce(function (flatArray, item) { return flatArray.concat(cb(item)); }, []);
};
var calculateEndPointAngles = function (lightSource, segment) {
    var x = lightSource.x, y = lightSource.y;
    var dx = 0.5 * (segment.p1.x + segment.p2.x) - x;
    var dy = 0.5 * (segment.p1.y + segment.p2.y) - y;
    segment.d = (dx * dx) + (dy * dy);
    segment.p1.angle = atan2(segment.p1.y - y, segment.p1.x - x);
    segment.p2.angle = atan2(segment.p2.y - y, segment.p2.x - x);
};
var setSegmentBeginning = function (segment) {
    var dAngle = segment.p2.angle - segment.p1.angle;
    if (dAngle <= -π)
        dAngle += 2 * π;
    if (dAngle > π)
        dAngle -= 2 * π;
    segment.p1.beginsSegment = dAngle > 0;
    segment.p2.beginsSegment = !segment.p1.beginsSegment;
};
var processSegments = function (lightSource, segments) {
    for (var i = 0; i < segments.length; i += 1) {
        var segment = segments[i];
        calculateEndPointAngles(lightSource, segment);
        setSegmentBeginning(segment);
    }
    return segments;
};
var getSegmentEndPoints = function (segment) { return [segment.p1, segment.p2]; };
export var loadSegments = function (rawSegments, lightSource) {
    var segments = processSegments(lightSource, __spreadArray([], rawSegments));
    return flatMap(getSegmentEndPoints, segments);
};
